import * as betgalaxy from './Countdown.styles.betgalaxy';
import * as betprofessor from './Countdown.styles.betprofessor';
import * as betroyale from './Countdown.styles.betroyale';
import * as fiestabet from './Countdown.styles.fiestabet';
import * as puntcity from './Countdown.styles.puntcity';
import * as puntgenie from './Countdown.styles.puntgenie';
import * as questbet from './Countdown.styles.questbet';
import * as sterlingparker from './Countdown.styles.sterlingparker';
import * as vikingbet from './Countdown.styles.vikingbet';
import * as volcanobet from './Countdown.styles.volcanobet';
import * as wellbet from './Countdown.styles.wellbet';
import * as goldenrush from './Countdown.styles.goldenrush';
import * as juicybet from './Countdown.styles.juicybet';
import * as junglebet from './Countdown.styles.junglebet';
import * as sugarcastle from './Countdown.styles.sugarcastle';
import * as oldgill from './Countdown.styles.oldgill';
import * as buffalobet from './Countdown.styles.buffalobet';
import * as titanbet from './Countdown.styles.titanbet';
import * as templebet from './Countdown.styles.templebet';
import * as goldenbet888 from './Countdown.styles.goldenbet888';
import * as slambet from './Countdown.styles.slambet';
import * as gigabet from './Countdown.styles.gigabet';
import * as betstride from './Countdown.styles.betstride';
import * as hyperbet from './Countdown.styles.hyperbet';
import * as bet777 from './Countdown.styles.bet777';
import * as chromabet from './Countdown.styles.chromabet';
import * as bet575 from './Countdown.styles.bet575';
import * as epicodds from './Countdown.styles.epicodds';
import * as magnumbet from './Countdown.styles.magnumbet';
import * as pyramidbet from './Countdown.styles.pyramidbet';

import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  buffalobet,
  oldgill,
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  goldenrush,
  juicybet,
  junglebet,
  sugarcastle,
  titanbet,
  templebet,
  goldenbet888,
  slambet,
  gigabet,
  betstride,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  magnumbet,
  pyramidbet,
};
